import { getPhoneNumberError } from "./phone.js";

// Same check as isValidEmail in ./email.ts, which the node test runner can't
// import.
const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

const REQUIRED_MESSAGES = {
  firstName: "Please enter your first name.",
  lastName: "Please enter your last name.",
  email: "Please enter your email address.",
  phone: "Please enter your phone number.",
  preferredContact: "Please choose how you'd like us to contact you.",
  interests: "Please choose what you're interested in.",
  location: "Please choose a location.",
  comments: "Please enter a message.",
};

/**
 * Validates a lead form submission and returns `{ [field]: message }` for
 * every field that needs fixing, so each form can show the message under the
 * field instead of a single "fill in all required fields" line.
 *
 * @returns {Record<string, string>}
 */
export function validateLeadForm(data, requiredFields) {
  const errors = {};

  requiredFields.forEach((field) => {
    if (!String(data[field] ?? "").trim()) {
      errors[field] = REQUIRED_MESSAGES[field] || "This field is required.";
    }
  });

  if (!errors.email && data.email?.trim() && !isValidEmail(data.email)) {
    errors.email = "Please enter a valid email address.";
  }

  if (!errors.phone && data.phone?.trim()) {
    const phoneError = getPhoneNumberError(data.phone);
    if (phoneError) errors.phone = phoneError;
  }

  return errors;
}
